import type {Editor} from 'grapesjs';

/** Registers PMW i18n strings with the GrapesJS locale. */
export function addI18nMessages(editor: Editor): void {
  const i18n = editor.I18n;

  i18n.addMessages({
    en: {
      styleManager: {
        fileButton: window.i18next.t('pmwjs_upload'),
      },
    },
  });
}
